import PropTypes from "prop-types";
import React from "react";
import Select from "react-select";
// import "react-select/dist/react-select.css"; // optional: ensure styles are applied

// Convert flat array to react-select format if needed
const formatOptions = (options) =>
  options.map((item) =>
    typeof item === "object" && item.label && item.value
      ? item
      : { label: item, value: item }
  );

function MultiDropdown({ name, options, handleChange, value }) {
  const formattedOptions = formatOptions(options);
  const formattedValue = formatOptions(value);

  return (
    <Select
      inputId={name}
      name={name}
      options={formattedOptions}
      value={formattedValue}
      onChange={(selected) => handleChange(name, selected)}
      isMulti
      closeMenuOnSelect={false}
      isClearable
    />
  );
}

MultiDropdown.propTypes = {
  name: PropTypes.string,
  options: PropTypes.array,
  handleChange: PropTypes.func,
  value: PropTypes.array,
};

MultiDropdown.defaultProps = {
  name: "multi",
  options: [],
  handleChange: () => { },
  value: [],
};

export default MultiDropdown;
